import { ApplicationDebtSource } from "@ploy-lib/types";
import { FieldType, DefaultFormTableSchema } from "./types";
export class ApplicationDebtSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            columnData: {
                customerId: { fieldType: FieldType.Select, isRequired: true },
                amount: { fieldType: FieldType.Currency, isRequired: true },
                originalAmount: { fieldType: FieldType.Currency },
                loanType: { fieldType: FieldType.Select, isRequired: true },
                refinance: { fieldType: FieldType.Checkbox },
                comment: { fieldType: FieldType.Text },
                source: {
                    fieldType: FieldType.Select,
                    defaultValue: ApplicationDebtSource.Applicant
                },
                creditLimit: { fieldType: FieldType.Currency },
                lender: { fieldType: FieldType.Text },
                loanNumber: { fieldType: FieldType.Text },
                nominalInterest: { fieldType: FieldType.Percent },
                refinanceAccount: { fieldType: FieldType.Text },
                refinanceAmount: { fieldType: FieldType.Currency },
                termAmount: { fieldType: FieldType.Currency },
                maturity: { fieldType: FieldType.Number }
            }
        });
    }
}
export class LimitedApplicationDebtSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            tableData: {
                isDeletableRow: (rowData, cells) => rowData["source"] === ApplicationDebtSource.Applicant
            },
            columnData: {
                customerId: {
                    fieldType: FieldType.Select,
                    isRequired: true,
                    isEditableFunctions: {
                        isEditable: (form, row) => {
                            const source = row.find(c => c.column.id === "source")?.value;
                            return source === ApplicationDebtSource.Applicant;
                        }
                    }
                },
                amount: { fieldType: FieldType.Currency, isRequired: true },
                originalAmount: { fieldType: FieldType.Currency },
                loanType: { fieldType: FieldType.Select, isRequired: true },
                refinance: { fieldType: FieldType.Checkbox },
                willBeFulfilled: { fieldType: FieldType.Checkbox },
                comment: { fieldType: FieldType.Text },
                source: {
                    fieldType: FieldType.Select,
                    defaultValue: ApplicationDebtSource.Applicant
                },
                lender: { fieldType: FieldType.Text },
                loanNumber: { fieldType: FieldType.Text }
            }
        });
    }
}
export class LimitedRefinancedApplicationDebtSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            tableData: {
                isDeletableRow: (rowData, cells) => rowData["source"] === ApplicationDebtSource.Applicant
            },
            columnData: {
                customerId: { fieldType: FieldType.Select, isRequired: true },
                amount: { fieldType: FieldType.Currency, isRequired: true },
                originalAmount: { fieldType: FieldType.Currency },
                loanType: { fieldType: FieldType.Select, isRequired: true },
                comment: { fieldType: FieldType.Text },
                source: { fieldType: FieldType.Select },
                lender: { fieldType: FieldType.Text, isRequired: true },
                loanNumber: { fieldType: FieldType.Text, isRequired: true },
                refinanceAccount: { fieldType: FieldType.Text },
                refinanceAmount: {
                    fieldType: FieldType.Currency,
                    isRequired: true
                }
            }
        });
    }
}
//# sourceMappingURL=ApplicationDebtSchema.js.map